import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { SiteLayout } from "@/components/site/SiteLayout";
import { Search, Clock, ArrowRight } from "lucide-react";

export default function Blog() {
  const [params, setParams] = useSearchParams();
  const [data, setData] = useState({ items: [], total: 0, pages: 1, page: 1 });
  const [search, setSearch] = useState(params.get("search") || "");
  const [cats, setCats] = useState([]);
  const category = params.get("category") || "";
  const page = Number(params.get("page") || 1);

  useEffect(() => { api.get("/blog/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const qs = new URLSearchParams({ page, limit: 9 });
    if (category) qs.set("category", category);
    if (params.get("search")) qs.set("search", params.get("search"));
    api.get(`/blog?${qs}`).then((r) => setData(r.data)).catch(() => {});
  }, [category, page, params]);

  const featured = data.items[0];
  const rest = data.items.slice(1);

  return (
    <SiteLayout>
      <Seo title="Blog - TakipciSatis.com" description="Sosyal medya büyütme ipuçları, rehberler ve haberler." canonical="https://takipcisatis.com/blog" />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-10">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white">Blog</h1>
          <p className="text-gray-400 mt-3">Sosyal medya büyütme rehberleri ve ipuçları.</p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 mb-8">
          <form onSubmit={(e) => { e.preventDefault(); const p = new URLSearchParams(params); p.set("search", search); p.set("page", 1); setParams(p); }}
            className="flex items-center gap-2 flex-1 bg-[#171922] border border-white/10 rounded-xl px-4">
            <Search size={18} className="text-gray-400" />
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Yazı ara..." className="flex-1 bg-transparent py-3 text-white outline-none placeholder:text-gray-500" data-testid="blog-search" />
          </form>
          <div className="flex gap-2 overflow-x-auto no-scrollbar">
            <button onClick={() => { const p = new URLSearchParams(params); p.delete("category"); p.set("page", 1); setParams(p); }}
              className={`px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap ${!category ? "bg-white text-[#1f222d]" : "bg-white/5 text-gray-300 hover:bg-white/10"}`} data-testid="blog-cat-all">Tümü</button>
            {cats.map((c) => (
              <button key={c.id} onClick={() => { const p = new URLSearchParams(params); p.set("category", c.name); p.set("page", 1); setParams(p); }}
                className={`px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap ${category === c.name ? "bg-white text-[#1f222d]" : "bg-white/5 text-gray-300 hover:bg-white/10"}`}>{c.name}</button>
            ))}
          </div>
        </div>

        {data.items.length === 0 && <div className="card-surface p-12 text-center text-gray-400">Henüz yazı bulunmuyor.</div>}

        {featured && (
          <Link to={`/blog/${featured.slug}`} className="card-surface card-hover overflow-hidden grid md:grid-cols-2 mb-8 group" data-testid="blog-featured">
            {featured.cover_image && <div className="h-56 md:h-full overflow-hidden"><img src={featured.cover_image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" /></div>}
            <div className="p-6 sm:p-8 flex flex-col justify-center">
              <span className="text-xs text-[#d8b4fe] font-semibold uppercase tracking-wider">{featured.category || "Öne Çıkan"}</span>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-white mt-2">{featured.title}</h2>
              <p className="text-gray-400 mt-3 line-clamp-3">{featured.excerpt}</p>
              <span className="text-sm font-semibold text-white mt-4 flex items-center gap-1">Devamını Oku <ArrowRight size={16} /></span>
            </div>
          </Link>
        )}

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} className="card-surface card-hover overflow-hidden group" data-testid={`blog-card-${p.slug}`}>
              {p.cover_image && <div className="h-44 overflow-hidden"><img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" loading="lazy" /></div>}
              <div className="p-5">
                {p.category && <span className="text-xs text-[#d8b4fe] font-medium">{p.category}</span>}
                <h3 className="font-bold text-white mt-1 line-clamp-2">{p.title}</h3>
                <p className="text-sm text-gray-400 mt-2 line-clamp-2">{p.excerpt}</p>
                <span className="text-xs text-gray-500 mt-3 flex items-center gap-1"><Clock size={12} />{(p.published_at || "").slice(0, 10)}</span>
              </div>
            </Link>
          ))}
        </div>

        {data.pages > 1 && (
          <div className="flex justify-center gap-2 mt-10">
            {Array.from({ length: data.pages }).map((_, i) => (
              <button key={i} onClick={() => { const p = new URLSearchParams(params); p.set("page", i + 1); setParams(p); }}
                className={`w-10 h-10 rounded-lg font-semibold ${page === i + 1 ? "bg-white text-[#1f222d]" : "bg-white/5 text-gray-300 hover:bg-white/10"}`}>{i + 1}</button>
            ))}
          </div>
        )}
      </section>
    </SiteLayout>
  );
}
